import { createMuiTheme } from '@material-ui/core/styles';

const colors = {
  primary: '#503868',
  secondary: '#323870',
  selected: '#545786',
  action: '#ffffff',
  success: '#009413',
  error: '#ee2d3d',
  purpleLight: '#d4d6ed',
  grayMedium: '#e1e1df',
  energy: 'linear-gradient(90deg, rgb(198, 2, 13) 0%, rgb(249, 0, 10) 100%)',
  primaryFaded: 'rgba(0, 8, 78, 0.9)',
  actionFaded: 'rgba(255, 255, 255, 0.4)',

  mainColor: '#303B77',
  mainColorFaded: 'rgba(48, 59, 119, 0.4)',
};

const theme = createMuiTheme({
  palette: {
    primary: {
      light: colors.secondary,
      main: colors.mainColor,
    },
    secondary: {
      main: colors.action,
    },
    error: {
      main: colors.error,
    },
    success: {
      main: colors.success,
    },
  },
  typography: {
    fontFamily: `Roboto Slab, DINCondensed, -apple-system, BlinkMacSystemFont, 'Segoe UI',
    'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
    'Helvetica Neue', 'sans-serif';`,
    button: {
      fontSize: '1rem',
      textTransform: 'none',
    },
  },
  overrides: {
    MuiPaper: {
      root: {
        backgroundColor: 'transparent',
      },
      elevation1: {
        boxShadow: 0,
      },
      rounded: {
        borderRadius: '10px',
      },
    },
    MuiButton: {
      outlined: {
        color: colors.mainColor,
        borderRadius: 0,
        fontWeight: '400',
        lineHeight: '1.25rem',
        border: `0.0625rem solid ${colors.mainColor}`,
        minHeight: '2.5rem',
        '&$disabled': {
          color: colors.mainColor,
          border: `0.0625rem solid ${colors.mainColor}`,
          opacity: 0.5,
        },
      },
    },
    MuiInputLabel: {
      formControl: {
        transform: 'translate(8px, 20px) scale(1)',
      },
      shrink: {
        transform: 'translate(8px, 12px) scale(0.75)',
      },
      root: {
        '&$error': {
          color: colors.error,
          '&$focused': {
            color: colors.error,
          },
        },
        color: colors.mainColor,
        '&$focused': {
          color: colors.mainColor,
        },
        '&$disabled': {
          color: colors.mainColor,
          '&$focused': {
            color: colors.mainColor,
          },
        },
      },
    },
    MuiFormHelperText: {
      root: {
        color: colors.action,
        paddingLeft: '0.5rem',
        fontSize: '0.875rem',
        lineHeight: '1.125rem',
        '&$disabled': {
          color: colors.mainColorFaded,
        },
      },
    },
    MuiFormControl: {
      root: {
        width: '100%',
        minWidth: '100%',
      },
    },
    MuiInput: {
      adornedEnd: {
        paddingRight: '0.625rem',
      },
      input: {
        '&:-webkit-autofill': {
          WebkitTextFillColor: colors.mainColor,
          WebkitBackgroundClip: 'text',
          caretColor: colors.mainColor,
        },
        padding: '0.75rem 0.5rem 0.625rem',
        height: '1.125rem',
      },
      root: {
        color: colors.mainColor,
        '&$disabled': {
          color: colors.mainColor,
          '&$focused': {
            color: colors.mainColor,
          },
          '&:hover': {
            color: colors.mainColor,
          },
        },
        '&$error': {
          color: colors.error,
          '&$focused': {
            color: colors.error,
          },
        },
      },
      underline: {
        '&:before': {
          borderBottom: `0.0625rem solid ${colors.mainColor}`,
        },
        '&:after': {
          borderBottom: `0.125rem solid ${colors.mainColor}`,
        },
        '&&:hover:before': {
          borderBottom: `0.0625rem solid ${colors.mainColor}`,
        },
        '&$disabled': {
          '&&:before': {
            borderBottom: `0.0625rem solid ${colors.mainColor}`,
          },
        },
      },
    },
    MuiInputAdornment: {
      root: {
        paddingBottom: '1rem',
        paddingRight: '0.5rem',
      },
    },
  },
});

export { theme };
